import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemCommonModule } from '../system-common/system-common.module';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DynamicKpiDetailsComponent } from './dynamic-kpi-details/dynamic-kpi-details.component';
import { ContestAndIncentiveDetailsService } from './services/contest-and-incentive-details.service';
import { ContestAndIncentiveDetailsRoutingModule } from './contest-and-incentive-details.routing.module';
import { MenuIncentiveItemComponent } from './menu-incentive-item/menu-incentive-item.component';
import { EvaluationDetailsComponent } from './evaluation-details/evaluation-details.component';
import { ShortFallComponent } from './shortfall/shortfall.component';
import { ContestDashboardSearchComponent } from './contest-dashboard-search/contest-dashboard-search.component';
import { IncentiveDashboardSearchComponent } from './incentive-dashboard-search/incentive-dashboard-search.component';
import { TrackingDashboardSearchComponent } from './tracking-dashboard-chart/tracking-dashboard-chart.component';
import { PromotionSearchComponent } from './promotion/promotion.component';
import { SegmentationSearchComponent } from './segmentation/segmentation.component';

@NgModule({
  declarations: [
    MenuIncentiveItemComponent,
    TrackingDashboardSearchComponent,
    ContestDashboardSearchComponent,
    IncentiveDashboardSearchComponent,
    PromotionSearchComponent,
    SegmentationSearchComponent,
    ShortFallComponent,
    EvaluationDetailsComponent,
    DynamicKpiDetailsComponent,
  ],
  imports: [
    CommonModule,
    SystemCommonModule,
    ContestAndIncentiveDetailsRoutingModule,
    FormsModule,
    NgSelectModule,
  ],
  exports: [
    ContestDashboardSearchComponent,
    IncentiveDashboardSearchComponent,
    PromotionSearchComponent,
    SegmentationSearchComponent,
    TrackingDashboardSearchComponent,
  ],
  providers: [ContestAndIncentiveDetailsService],
})
export class ContestAndIncentiveDetailsModule {}
